// État du catalogue global des produits canoniques adoptables.
//
// La liste est chargée à la demande, lorsque l'utilisateur bascule sur
// « Catalogue » : la garder hors de l'amorçage de l'écran Stock évite de
// payer ses milliers d'entrées à ceux qui ne s'en servent pas.
export function catalogueReducer(state = {
    produits: [],
    loading: false,
    loaded: false,
    error: "",
    adopting: "",
    disabling: "",
}, {
    type,
    payload
}) {

    switch (type) {
        case "FETCH_CATALOGUE_START":
            return {
                ...state,
                loading: true,
                error: "",
            };

        case "FETCH_CATALOGUE_FULFILLED":
            return {
                ...state,
                loading: false,
                loaded: true,
                error: "",
                produits: payload,
            };

        case "FETCH_CATALOGUE_ERROR":
            return {
                ...state,
                loading: false,
                loaded: true,
                error: payload,
            };

        case "ADOPT_CATALOGUE_START":
            return {
                ...state,
                adopting: payload,
                error: "",
            };

        // L'entrée adoptée est marquée ici même, sans relire le catalogue :
        // celui-ci compte des milliers de lignes et son seul champ mouvant est
        // celui-là.
        case "ADOPT_CATALOGUE_FULFILLED":
            return {
                ...state,
                adopting: "",
                produits: state.produits.map(produit => (
                    produit.id === payload
                        // Adopter réactive : une entrée désactivée ne l'est
                        // plus, sans quoi elle garderait sa mention
                        // « Désactivé » à côté de « Déjà dans mes produits ».
                        ? { ...produit, deja_adopte: true, desactive: false }
                        : produit
                )),
            };

        case "ADOPT_CATALOGUE_ERROR":
            return {
                ...state,
                adopting: "",
                error: payload,
            };

        case "DISABLE_CATALOGUE_START":
            return {
                ...state,
                disabling: payload,
            };

        // Même parti que pour l'adoption : l'entrée est retournée sur place.
        // Un produit désactivé n'est plus « adopté », c'est ce qui rend le
        // bouton « Ajouter » de nouveau disponible pour le réactiver.
        case "DISABLE_CATALOGUE_FULFILLED":
            return {
                ...state,
                disabling: "",
                produits: state.produits.map(produit => (
                    produit.id === payload
                        ? { ...produit, deja_adopte: false, desactive: true }
                        : produit
                )),
            };

        // L'échec n'est pas rangé dans error : ce champ remplace le tableau du
        // catalogue par un message et un bouton « Réessayer », alors qu'une
        // désactivation refusée ne dit rien de l'état du catalogue. Le message
        // part à l'utilisateur par l'erreur que lève l'action.
        case "DISABLE_CATALOGUE_ERROR":
            return {
                ...state,
                disabling: "",
            };

        default:
            return state;
    }

}
